import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityRequestCaruse } from "../../entity/EntityRequestCaruse";

export class DtoRequestCarusesPostReq extends EntityRequestCaruse {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------

    return res;
  }
}
